import { PlusCircleFilled } from '@ant-design/icons';
import { Flex } from '@ui-library/misc';
import Button from '@ui-library/button';
import React from 'react';
import { FixMe } from '@utils/types';
import { useConnectionState, IField } from '../../../visualDataMappingProvider';
import classes from './select-field-mapping.module.scss';
import PopOverFieldMapping from './PopOverFieldMapping';

interface SelectFieldMappingProps {
  onSelect: (field: IField) => void;
  onChangeMapping?: (
    mapping: { original?: string; mapped?: string },
    cl: FixMe,
    index?: number,
  ) => void;
}

const SelectFieldMapping = ({ onSelect, onChangeMapping }: SelectFieldMappingProps) => {
  const { viewOnly } = useConnectionState();
  const [addNewField, setAddNewField] = React.useState(false);
  return !viewOnly ? (
    <Flex className={classes.add_field_button_container}>
      {addNewField && (
        <PopOverFieldMapping
          addNewField={addNewField}
          changeVisible={(a: boolean) => {
            setAddNewField(a);
          }}
          onSelect={onSelect}
          onChangeMapping={onChangeMapping}
        />
      )}
      {!addNewField && (
        <Button
          secondary
          className={classes.add_field_button}
          onClick={(event: FixMe) => {
            event.preventDefault();
            event.stopPropagation();
            setAddNewField(true);
          }}
        >
          <PlusCircleFilled className={classes.plus_button} />
          &nbsp; Map another field
        </Button>
      )}
    </Flex>
  ) : null;
};
export default SelectFieldMapping;
